import { cn } from '../lib/classnames';

interface WordmarkProps {
  /** 'sm' fits a nav, 'lg' is a hero display. */
  size?: 'sm' | 'md' | 'lg';
  wrap?: boolean;
  className?: string;
}

/**
 * "Chess: Challenge Cards" wordmark.
 *
 * The visual idea: "Chess" sits in a formal serif (Fraunces) with tight tracking;
 * the colon is small and accent-colored (a card-table marker); "Challenge Cards"
 * picks up in the same face but with a slightly looser optical size and a darker
 * weight, like a TCG card title. The two halves read as two voices of the same
 * brand — old game, new format.
 */
export function Wordmark({ size = 'md', wrap = false, className }: WordmarkProps) {
  const sizes = {
    sm: 'text-xl',
    md: 'text-3xl',
    lg: 'text-[clamp(40px,7vw,84px)]',
  } as const;
  return (
    <span
      aria-label="Chess: Challenge Cards"
      className={cn(
        'font-display font-black wordmark-display select-none leading-none',
        wrap ? 'whitespace-normal' : 'whitespace-nowrap',
        sizes[size],
        className,
      )}
    >
      <span className="text-ink">Chess</span>
      <span className="text-accent mx-[0.08em]">:</span>
      <span aria-hidden className="inline-block w-[0.12em]" />
      <span className="text-ink/95">Challenge</span>
      <span className="ml-[0.18em] text-ink">Cards</span>
    </span>
  );
}
